import { render, staticRenderFns } from "./DiscountUsersView.vue?vue&type=template&id=ca97b0b2&"
import script from "./DiscountUsersView.vue?vue&type=script&lang=js&"
export * from "./DiscountUsersView.vue?vue&type=script&lang=js&"
import style0 from "./DiscountUsersView.vue?vue&type=style&index=0&id=ca97b0b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports